import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../NewBusinessWizard/Components/SharedComponents";

interface IISASectionProps extends IProcessComponentProps {}

interface IISASectionState {}

export class ISASection extends ProcessComponent<IISASectionProps, IISASectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private onProductChange(changes, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        for (const key in changes) {
            _product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = _product;
        this.props.onChange({ SelectedProducts: data });
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.StocksIsa);
        const Product = data.SelectedProducts[productIndex];
        return (
            <>
                {SectionHeader("ISA options")}
                {TrueFalseRadio(
                    "Will your client be taking regular withdrawals?",
                    "IsAddRegularWithdrawalSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-150 mb-16", disabled: data?.Disabled }
                )}
                <hr className="mb-12" />
            </>
        );
    }
}
